
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import Auth from '@/components/Auth';

interface AuthDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const AuthDialog = ({ open, onOpenChange }: AuthDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Sign In or Create Account</DialogTitle>
          <DialogDescription className="text-sm text-gray-500">
            Your data is securely handled. We use Google sign-in to simplify the login process.
          </DialogDescription>
        </DialogHeader>
        <div className="py-4">
          <Auth />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AuthDialog;
